import { ToastContainer, toast } from 'react-toastify';

import { CheckMarkIcon, InfoIcon, WarningIcon } from '@/components/common';

export function AppToastContainer() {
  return (
    <ToastContainer
      draggable
      pauseOnFocusLoss
      pauseOnHover
      role="alert"
      position="top-right"
      closeButton
      closeOnClick
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
    />
  );
}

function ToastContent({
  title,
  message,
}: {
  readonly title: string;
  readonly message?: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <h4 className="font-bold">{title}</h4>
      {message && <p>{message}</p>}
    </div>
  );
}

export function triggerSuccessToast(title: string, message?: string): void {
  toast.success(
    <ToastContent
      title={title}
      message={message}
    />,
    {
      className: 'text-success',
      progressClassName: 'bg-success',
      icon: <CheckMarkIcon className="w-4 h-5 text-success" />,
    },
  );
}

export function triggerInfoToast(title: string, message?: string): void {
  toast.info(
    <ToastContent
      title={title}
      message={message}
    />,

    {
      className: 'text-info',
      progressClassName: 'bg-info',
      icon: <InfoIcon className="w-4 h-5 text-info" />,
    },
  );
}

export function triggerWarningToast(title: string, message?: string): void {
  toast.warn(
    <ToastContent
      title={title}
      message={message}
    />,

    {
      className: 'text-warn',
      progressClassName: 'bg-warn',
      icon: <WarningIcon className="w-4 h-5 text-warn" />,
    },
  );
}

export function triggerErrorToast(title: string, message?: string): void {
  toast.error(
    <ToastContent
      title={title}
      message={message}
    />,

    {
      className: 'text-error',
      progressClassName: 'bg-error',
      icon: <WarningIcon className="w-4 h-5 text-error" />,
    },
  );
}
